const ExtraAbsorbentSVG = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
      <style>
        {`
        .st0, .st3 {
          fill: none;
          stroke: #063;
          strokeWidth: 2;
          strokeLinecap: round;
          stroke-miterlimit: 10;
        }
        .st3 {
          stroke: #063;
          strokeWidth: 2.0572;
        }
        .triangle {
          fill: #063;
        }
      `}
      </style>
      <path
        className="st0"
        d="M54 59.5c0-5-9-19-9-19s-9 14-9 19 4 9 9 9 9-4 9-9zM45 64.5c-2.8 0-5-2.2-5-5M92 59.5c0-5-9-19-9-19s-9 14-9 19 4 9 9 9 9-4 9-9zM83 64.5c-2.8 0-5-2.2-5-5M25 78.5c3.9 0 3.9 3 7.8 3s3.9-3 7.8-3 3.9 3 7.8 3 3.9-3 7.8-3 3.9 3 7.8 3 3.9-3 7.8-3 3.9 3 7.8 3 3.9-3 7.8-3"
      />
      <path
        d="M25 84.5c3.9 0 3.9 3 7.8 3s3.9-3 7.8-3 3.9 3 7.8 3 3.9-3 7.8-3 3.9 3 7.8 3 3.9-3 7.8-3 3.9 3 7.8 3 3.9-3 7.8-3 3.9 3 7.8 3 3.9-3 7.8-3"
        fill="none"
        stroke="#063"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
      <path
        d="M25 90.8c0-.1.7.3 1.6 1 0 0 2.3 1.8 6.2 1.8s3.9-3 7.8-3 3.9 3 7.8 3 3.9-3 7.8-3 3.9 3 7.8 3 3.9-3 7.8-3 3.9 3 7.8 3 6.2-1.8 6.2-1.8c.9-.7 1.6-1.1 1.6-1V95c0 1.1-.9 2-2 2H27c-1.1 0-2-.9-2-2v-2-2.2z"
        fill="none"
        stroke="#063"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
      <path className="st3" d="M94.6 42.1V31M32.6 42.1V31" />
      <path
        className="st0"
        d="M33.5 65.5l-7.1 7.1c-.8.8-.5 1.4.6 1.4h74c1.1 0 1.4-.6.6-1.4l-7.1-7.1"
      />
      <path
        className="st0"
        d="M56 66.5c2.1 1.9 5 3 8 3 3.1 0 5.9-1.2 8-3M73.6 48.8C70 40.9 64 31.5 64 31.5s-6 9.4-9.6 17.3M64 64.1c-3.7 0-6.8-3-6.8-6.8"
      />
      <path className="triangle" d="M94.6 47.8l4-6.9h-8zM32.6 47.8l4-6.9h-8z" />
    </svg>
  );
};

export default ExtraAbsorbentSVG;
